// document.addEventListener("DOMContentLoaded", function () {
//   new Swiper(".customBannerSwiper", {
//     loop: true,
//     autoplay: {
//       delay: 5000,
//       disableOnInteraction: false,
//     },
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {

      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");

      const target = tab.getAttribute("data-tab");
      document.getElementById(target).classList.add("active");

    });
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const scrollBtn = document.querySelector(".scroll-top");

  if (!scrollBtn) return;

  // Show/hide button on scroll
  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      scrollBtn.style.display = "block";
    } else {
      scrollBtn.style.display = "none";
    }
  });

  // Scroll to top on click
  scrollBtn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

 $(document).ready(function(){
    $('.brands-slider').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  });


let captchaValue = '';

function randomColor() {
  const colors = ['#ff6b6b','#6bcB77','#4d96ff','#f7b801','#9d4edd'];
  return colors[Math.floor(Math.random() * colors.length)];
}

function generateCaptcha() {
  const canvas = document.getElementById("captchaCanvas");
  const ctx = canvas.getContext("2d");

  // Clear
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Background gradient
  const gradient = ctx.createLinearGradient(0, 0, 120, 40);
  gradient.addColorStop(0, "#f0f0f0");
  gradient.addColorStop(1, "#dcdcdc");
  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // Generate code
  captchaValue = Math.floor(10000 + Math.random() * 90000).toString();

  // Draw text (colorful + rotated)
  for (let i = 0; i < captchaValue.length; i++) {
    ctx.save();
    ctx.font = "20px Arial";
    ctx.fillStyle = randomColor();

    let x = 15 + i * 18;
    let y = 25;

    let angle = (Math.random() - 0.5) * 0.5;
    ctx.translate(x, y);
    ctx.rotate(angle);

    ctx.fillText(captchaValue[i], 0, 0);
    ctx.restore();
  }

  // Add noise lines
  for (let i = 0; i < 3; i++) {
    ctx.strokeStyle = randomColor();
    ctx.beginPath();
    ctx.moveTo(Math.random() * 120, Math.random() * 40);
    ctx.lineTo(Math.random() * 120, Math.random() * 40);
    ctx.stroke();
  }
}

document.addEventListener("DOMContentLoaded", function () {
  generateCaptcha();

  document.getElementById("ContactForm").addEventListener("submit", function (e) {
    const userInput = document.getElementById("captcha-input").value;
    const error = document.getElementById("captcha-error");

    if (userInput !== captchaValue) {
      e.preventDefault();
      error.style.display = "block";
      generateCaptcha(); // refresh on wrong
    } else {
      error.style.display = "none";
    }
  });
});


document.querySelectorAll('.brand-nav a').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();

    const targetId = this.getAttribute('href');
    const target = document.querySelector(targetId);

    if (!target) return;

    // Detect header height dynamically (better than fixed value)
    const header = document.querySelector('header');
    const headerOffset = header ? header.offsetHeight : 100;

    const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset - 10; // extra spacing

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('submit', function(e) {
    const form = e.target;

    if (form.matches('form[action*="/cart/add"]')) {
      e.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = '/cart'; // redirect to cart page
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const desc = document.getElementById("collectionDesc");
  const btn = document.getElementById("toggleDescBtn");

  if (!desc || !btn) return;

  let isExpanded = false;
  const collapsedHeight = 120;

  // Hide button if content is small
  if (desc.scrollHeight <= collapsedHeight) {
    btn.style.display = "none";
    return;
  }

  btn.addEventListener("click", function () {
    if (!isExpanded) {
      // Expand smoothly
      desc.style.maxHeight = desc.scrollHeight + "px";
      btn.textContent = "Show Less";
    } else {
      // Collapse smoothly
      desc.style.maxHeight = collapsedHeight + "px";
      btn.textContent = "Show More";
    }

    isExpanded = !isExpanded;
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const drawer = document.querySelector(".menu-drawer-container");

  if (!drawer) return;

  drawer.addEventListener("toggle", function () {
    if (drawer.open) {
      document.body.classList.add("menu-drawer-open");
    } else {
      document.body.classList.remove("menu-drawer-open");
    }
  });
});

jQuery(document).ready(function ($) {
  $('.product-form, .wholesale-enquery').wrapAll('<div class="wrapper-class"></div>');
});

jQuery(document).ready(function ($) {

  $('a[href="#ContactForm"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $('#ContactForm').offset().top - 120
    }, 800);

  });

});